import { createMuiTheme } from '@material-ui/core/styles';
import amber from '@material-ui/core/colors/amber';
import red from '@material-ui/core/colors/red';
import primaryColor from '../colors/app-primary';

const theme = createMuiTheme({
	palette: {
		primary: primaryColor,
		secondary: red,
		error: amber,
	},

	"spacing": {
		"unit": 5,
	},

	"typography": {
		useNextVariants: true,
		suppressDeprecationWarnings: true,
		"fontFamily": "\"Segoe UI\", \"Helvetica\", \"Arial\", sans-serif",
		"fontSize": 14,
		"fontWeightLight": 300,
		"fontWeightRegular": 400,
		"fontWeightMedium": 500,
		"h1": {
			"fontSize": "7rem",
			"fontWeight": 300,
			"fontFamily": "\"Segoe UI\", \"Helvetica\", \"Arial\", sans-serif",
			"letterSpacing": "-.04em",
			"lineHeight": "1.14286em",
			"marginLeft": "-.06em",
			"color": "rgba(0, 0, 0, 0.54)"
		},
		"h2": {
			"fontSize": "3.5rem",
			"fontWeight": 400,
			"fontFamily": "\"Segoe UI\", \"Helvetica\", \"Arial\", sans-serif",
			"letterSpacing": "-.02em",
			"lineHeight": "1.30357em",
			"marginLeft": "-.04em",
			"color": "rgba(0, 0, 0, 0.54)"
		},
		"h3": {
			"fontSize": "2.8125rem",
			"fontWeight": 400,
			"fontFamily": "\"Segoe UI\", \"Helvetica\", \"Arial\", sans-serif",
			"lineHeight": "1.06667em",
			"marginLeft": "-.04em",
			"color": "rgba(0, 0, 0, 0.54)"
		},
		"h4": {
			"fontSize": "2.125rem",
			"fontWeight": 400,
			"fontFamily": "\"Segoe UI\", \"Helvetica\", \"Arial\", sans-serif",
			"lineHeight": "1.20588em",
			"marginLeft": "-.04em",
			"color": "rgba(0, 0, 0, 0.54)"
		},
		"h5": {
			"fontSize": "1.5rem",
			"fontWeight": 400,
			"fontFamily": "\"Segoe UI\", \"Helvetica\", \"Arial\", sans-serif",
			"lineHeight": "1.35417em",
			"color": "rgba(0, 0, 0, 0.87)"
		},
		"h6": {
			"fontSize": "1.3125rem",
			"fontWeight": 500,
			"fontFamily": "\"Segoe UI\", \"Helvetica\", \"Arial\", sans-serif",
			"lineHeight": "1.16667em",
			"color": "rgba(0, 0, 0, 0.87)"
		},
		"subtitle1": {
			"fontSize": "1rem",
			"fontWeight": 400,
			"fontFamily": "\"Segoe UI\", \"Helvetica\", \"Arial\", sans-serif",
			"lineHeight": "1.5em",
			"color": "rgba(0, 0, 0, 0.87)"
		},
		"body1": {
			"fontSize": "0.875rem",
			"fontWeight": 500,
			"fontFamily": "\"Segoe UI\", \"Helvetica\", \"Arial\", sans-serif",
			"lineHeight": "1.71429em",
			"color": "rgba(0, 0, 0, 0.87)"
		},
		"body2": {
			"fontSize": "0.875rem",
			"fontWeight": 400,
			"fontFamily": "\"Segoe UI\", \"Helvetica\", \"Arial\", sans-serif",
			"lineHeight": "1.46429em",
			"color": "rgba(0, 0, 0, 0.87)"
		},
		"caption": {
			"fontSize": "0.75rem",
			"fontWeight": 400,
			"fontFamily": "\"Segoe UI\", \"Helvetica\", \"Arial\", sans-serif",
			"lineHeight": "1.375em",
			"color": "rgba(0, 0, 0, 0.54)"
		},
		"button": {
			"fontSize": 14,
			"textTransform": "uppercase",
			"fontWeight": 500,
			"fontFamily": "\"Segoe UI\", \"Helvetica\", \"Arial\", sans-serif"
		}
	},

	"shadows": [
		"none",
		"0px 2px 3px 0px rgba(0, 0, 0, 0.3),0px 4px 5px 0px rgba(0, 0, 0, 0.06),0px 2px 1px -1px rgba(0, 0, 0, 0.04)",
		"0px 2px 5px 0px rgba(0, 0, 0, 0.3),0px 2px 2px 0px rgba(0, 0, 0, 0.06),0px 3px 1px -2px rgba(0, 0, 0, 0.04)",
		"0px 2px 9px 0px rgba(0, 0, 0, 0.3),0px 1px 3px 0px rgba(0, 0, 0, 0.06),0px 3px 3px -2px rgba(0, 0, 0, 0.04)",
		"0px 4px 4px -1px rgba(0, 0, 0, 0.3),0px 0px 5px 0px rgba(0, 0, 0, 0.06),0px 1px 10px 0px rgba(0, 0, 0, 0.04)",
		"0px 6px 6px -1px rgba(0, 0, 0, 0.3),0px -1px 10px 0px rgba(0, 0, 0, 0.06),0px 1px 14px 0px rgba(0, 0, 0, 0.04)",
		"0px 6px 6px -1px rgba(0, 0, 0, 0.3),0px -2px 12px 0px rgba(0, 0, 0, 0.06),0px 1px 18px 0px rgba(0, 0, 0, 0.04)",
		"0px 7px 6px -2px rgba(0, 0, 0, 0.3),0px -1px 12px 1px rgba(0, 0, 0, 0.06),0px 2px 16px 1px rgba(0, 0, 0, 0.04)",
		"0px 10px 6px -3px rgba(0, 0, 0, 0.3),0px 0px 12px 1px rgba(0, 0, 0, 0.06),0px 3px 14px 2px rgba(0, 0, 0, 0.04)",
		"0px 10px 7px -3px rgba(0, 0, 0, 0.3),0px 1px 14px 1px rgba(0, 0, 0, 0.06),0px 3px 16px 2px rgba(0, 0, 0, 0.04)",
		"0px 11px 7px -3px rgba(0, 0, 0, 0.3),0px 2px 16px 1px rgba(0, 0, 0, 0.06),0px 4px 18px 3px rgba(0, 0, 0, 0.04)",
		"0px 11px 8px -4px rgba(0, 0, 0, 0.3),0px 3px 17px 1px rgba(0, 0, 0, 0.06),0px 4px 20px 3px rgba(0, 0, 0, 0.04)",
		"0px 13px 9px -4px rgba(0, 0, 0, 0.3),0px 4px 19px 2px rgba(0, 0, 0, 0.06),0px 5px 22px 4px rgba(0, 0, 0, 0.04)",
		"0px 13px 9px -4px rgba(0, 0, 0, 0.3),0px 5px 21px 2px rgba(0, 0, 0, 0.06),0px 5px 24px 4px rgba(0, 0, 0, 0.04)",
		"0px 13px 10px -4px rgba(0, 0, 0, 0.3),0px 6px 23px 2px rgba(0, 0, 0, 0.06),0px 5px 26px 4px rgba(0, 0, 0, 0.04)",
		"0px 15px 10px -5px rgba(0, 0, 0, 0.3),0px 7px 24px 2px rgba(0, 0, 0, 0.06),0px 6px 28px 5px rgba(0, 0, 0, 0.04)",
		"0px 15px 12px -5px rgba(0, 0, 0, 0.3),0px 8px 26px 2px rgba(0, 0, 0, 0.06),0px 6px 30px 5px rgba(0, 0, 0, 0.04)",
		"0px 15px 13px -5px rgba(0, 0, 0, 0.3),0px 9px 28px 2px rgba(0, 0, 0, 0.06),0px 6px 32px 5px rgba(0, 0, 0, 0.04)",
		"0px 17px 13px -5px rgba(0, 0, 0, 0.3),0px 10px 30px 2px rgba(0, 0, 0, 0.06),0px 7px 34px 6px rgba(0, 0, 0, 0.04)",
		"0px 17px 14px -6px rgba(0, 0, 0, 0.3),0px 11px 31px 2px rgba(0, 0, 0, 0.06),0px 7px 36px 6px rgba(0, 0, 0, 0.04)",
		"0px 19px 15px -6px rgba(0, 0, 0, 0.3),0px 12px 33px 3px rgba(0, 0, 0, 0.06),0px 8px 38px 7px rgba(0, 0, 0, 0.04)",
		"0px 19px 15px -6px rgba(0, 0, 0, 0.3),0px 13px 35px 3px rgba(0, 0, 0, 0.06),0px 8px 40px 7px rgba(0, 0, 0, 0.04)",
		"0px 19px 16px -6px rgba(0, 0, 0, 0.3),0px 14px 37px 3px rgba(0, 0, 0, 0.06),0px 8px 42px 7px rgba(0, 0, 0, 0.04)",
		"0px 20px 16px -7px rgba(0, 0, 0, 0.3),0px 15px 38px 3px rgba(0, 0, 0, 0.06),0px 9px 44px 8px rgba(0, 0, 0, 0.04)",
		"0px 20px 18px -7px rgba(0, 0, 0, 0.3),0px 16px 40px 3px rgba(0, 0, 0, 0.06),0px 9px 46px 8px rgba(0, 0, 0, 0.04)"
	],

	overrides: {
		MuiAppBar: {
			root: {
				boxShadow: 'none',
			},
		},
		MuiInput: {
			input: {
				fontSize: '0.8rem',
			},
		},
		MuiFormLabel: {
			root: {
				fontSize: '1rem',
				whiteSpace: 'nowrap',
				textOverflow: 'ellipsis',
				overflow: 'hidden',
				width: '100%',
				fontWeight: '900',
				color: primaryColor[500],
			},
		},
		MuiInputLabel: {
			root: {
				fontSize: '1rem',
				whiteSpace: 'nowrap',
				textOverflow: 'ellipsis',
				overflow: 'hidden',
				fontWeight: '900',
				color: primaryColor[500],
			},
			shrink: {
				width: '132%',
			},
		},
		MuiTableRow: {
			root: {
				height: 36,
			},
		},
		MuiTableCell: {

			root: {
				padding: '2px 4px 2px 4px',
			},

			head: {
				fontWeight: '900',
				textShadow: '0px 0px 1px',
				color: primaryColor[500],
			},
		},
		MuiTableHead: {
			root: {
				fontSize: '0.85rem',
			},
		},
		MuiTab: {
			label: {
				fontWeight: '900',
				textShadow: '0px 0px 1px',
			},
		},
		MuiButton: {
			root: {
				fontSize: '0.8rem',
				padding: '12px 12px',
				minWidth: 64,
				minHeight: 20,
				lineHeight: '1.0em',
			},
		},
		MuiTouchRipple: {
			root: {
				opacity: .5,
			},
			/*
			wrapper: {
				opacity: .5,
			},
			wrapperLeaving: {
				animation: 'none',
			},
			wrapperPulsating: {
				animation: 'none',
			},
			*/
			rippleVisible: {
				animation: 'none',
			},
		},
		MuiTableSortLabel: {
			root: {
				fontWeight: 'bold',
			},
		},
	},

});

export default theme;